module.exports = __webpack_public_path__ + "img/figure-9.27f029e5.png";